module.exports = __webpack_public_path__ + "img/banner-tc5.2eefcb58.jpg";